import { render, staticRenderFns } from "./RejectProjectDeletionModal.vue?vue&type=template&id=f2b7a6ae&scoped=true&"
import script from "./RejectProjectDeletionModal.vue?vue&type=script&lang=js&"
export * from "./RejectProjectDeletionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b7a6ae",
  null
  
)

export default component.exports